module.exports = __webpack_public_path__ + "img/image1.7cb0dcb9.jpeg";